import React from "react";
import { createTheme, ThemeProvider, CssBaseline } from "@mui/material";
import AppRoutes from "./AppRoutes";

const theme = createTheme({
  palette: {
    primary: { main: "#1565C0" },
    secondary: { main: "#0288d1" },
  },
  shape: { borderRadius: 10 },
  typography: { fontFamily: "Arial, sans-serif" },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRoutes />
    </ThemeProvider>
  );
}
